import { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useNavigate, useOutletContext } from "react-router-dom";
// helpers
import { getSelectedHotelSaasModel, saasModelOption } from "@gl-shared/shared/helpers";
import { pagesUrl, appSection, hotelPanelRootUrl } from "../../common/utils/panel-helpers/helpers";
import {
  getEditOfferDataFormattedBySteps,
  getHotelCurrency,
  getSelectedHotelTermsAndConditions,
  offersToAddLimit
} from "./offersHelpers";
// components
import SectionLoader from "../../components/SectionLoader";
import FormMessage from "../../components/FormMessage";
import { CustomButton } from "@gl-shared/shared/ui";
// Hotel Offers components
import OffersList from "./OffersList";
import OffersTermsAndConditions from "./OffersTermsAndConditions";
// actions
import { offersActionCreators } from "../../common/store/modules/offersModule";
import { globalActionCreators } from "../../common/store/modules/globalModule";
import { errorFieldActionCreators } from "../../common/store/modules/errorFieldModule";

const Offers = props => {
  const outletContext = useOutletContext();
  const navigate = useNavigate();

  const hotelCurrency = getHotelCurrency(props.isHotelGroupExists, props.selectedHotels[0], props.hotelData);

  const isTermsApproved = getSelectedHotelTermsAndConditions(
    props.isHotelGroupExists,
    props.selectedHotels[0],
    props.hotelData
  );

  useEffect(() => {
    // call loadOffers initially (after we get hotel-info data) and on every hotel change
    if (props?.hotelData?.hotelUserId) {
      outletContext?.loadOffers(props.selectedHotels[0]?.id);
    }
  }, [props.selectedHotels[0]?.id, props.hotelData]);

  // resetting Offer and Error Field states when user clicks on "Add Offer" || "Edit" button
  const resetOfferState = () => {
    // Reset all steps data to initial values & reset to initial step
    props.resetOfferStepDataAction();
    // Reset errorFieldModule state
    props.resetErrorFieldAction();
  };

  const handleEditOfferButton = offer => {
    resetOfferState();
    // reset isFormChanged to default false value
    props.setIfFormChangedAction(false);
    navigate(`/${hotelPanelRootUrl}/offers/edit/${offer?.event_code}`);
    const formattedOffer = getEditOfferDataFormattedBySteps(offer);
    props.setOfferForEditAction(formattedOffer);
    window.scrollTo(0, 0);
  };

  const getMaximumNumOfOffers = () => {
    const selectedHotelSaasModel = getSelectedHotelSaasModel(
      props.isHotelGroupExists,
      props.selectedHotels[0]?.saas_model,
      props.hotelData.defaultHotelSaasModel
    );
    if (
      selectedHotelSaasModel === saasModelOption.hotel.premiumPlus ||
      selectedHotelSaasModel === saasModelOption.hotel.enterprise
    ) {
      return "unlimited";
    } else {
      return offersToAddLimit;
    }
  };

  const handleAddOfferButton = () => {
    resetOfferState();
    // reset isFormChanged to default false value
    props.setIfFormChangedAction(false);

    navigate(`/${hotelPanelRootUrl}/${pagesUrl.newOffer}`);
  };

  return (
    <div className="hotel-offers component">
      {props.sectionLoadingNames === null || props.sectionLoadingNames?.includes(appSection?.offers) ? (
        <SectionLoader loadingLabel="LOADING OFFERS" />
      ) : (
        <>
          <>
            <FormMessage
              form={props.formData?.form}
              formError={props.formData?.formError}
              formSuccessful={props.formData?.formSuccessful}
              hotelName={props.formData?.hotelName}
            />
            {isTermsApproved ? (
              <div className="row hotel-offers__box hotel-offers__box--max-width-900">
                <div className="col-lg-12">
                  <div className="ibox">
                    <div className="ibox-title">
                      <h5>Hotel Offers</h5>
                      <div className="ibox-button_section ibox-button_section--margin-right">
                        <CustomButton
                          isDisabled={
                            Number.isInteger(getMaximumNumOfOffers())
                              ? props?.panelOffers?.length > getMaximumNumOfOffers() - 1
                              : false
                          }
                          mainClass="btn-green"
                          customClasses="btn-green--height-l btn-green--auto-width"
                          // customClasses={
                          //   props?.panelOffers.length > maximumNumberOfOffers - 1 && "btn-green--disabled"
                          // }
                          onClick={handleAddOfferButton}
                          buttonText="Add Offer"
                        />
                      </div>
                    </div>

                    <OffersList
                      hotelCurrency={hotelCurrency}
                      panelOffers={props?.panelOffers}
                      maximumNumberOfOffers={getMaximumNumOfOffers()}
                      onEditButton={handleEditOfferButton}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <OffersTermsAndConditions
                handleFormMessage={outletContext.handleFormMessage}
                handleSectionLoader={outletContext.handleSectionLoader}
              />
            )}
          </>
        </>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  panelOffers: state.offers.panelOffers,
  sectionLoadingNames: state.global.sectionLoadingNames,
  selectedHotels: state.global.selectedHotels,
  formData: state.global.formData,
  hotelData: state.home.hotelData,
  isHotelGroupExists: state.home.isHotelGroupExists
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      setOfferForEditAction: offersActionCreators.setOfferForEditAction,
      setIfFormChangedAction: offersActionCreators.setIfFormChangedAction,
      toggleSectionLoaderAction: globalActionCreators.toggleSectionLoaderAction,
      setFormDataAction: globalActionCreators.setFormDataAction,
      resetOfferStepDataAction: offersActionCreators.resetOfferStepDataAction,
      resetErrorFieldAction: errorFieldActionCreators.resetErrorFieldAction
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Offers);
